import { MODES } from "@/enums/apps.enum";
import { ORDER_SOURCE } from "@/enums/orders.enum";

const ENDPOINTS = {
  BASE_URL: process.env.VUE_APP_BASE_URL,
  // BASE_URL: "https://internal-api.rocketinfra.com/", //process.env.VUE_APP_BASE_URL,
  OOC_BASE_URL: process.env.VUE_APP_OOC_BASE_URL,
  OOC: {
    LOGIN: "oauth/login",
    ME: "oauth/me",
    MERCHANTS: "business/",
    LOCATIONS: (businessId) => `business/${businessId}/locations/`,
    ONE_MERCHANT: (businessId) => `business/${businessId}`,
    MENUS: (businessId: string) => `business/${businessId}/menu/`,
    ONE_MENU: (businessId: string, menuId: string) => `business/${businessId}/menu/${menuId}`,
    MENU_INTEGRATION: (businessId: string, integrationLocationId: string) =>
      `business/${businessId}/integration-location/${integrationLocationId}/menu`,
    CATALOG_CATEGORIES: (businessId: string) => `business/${businessId}/catalog/categories`,
    CATALOG_ITEMS: (businessId: string, locationId: string) =>
      `business/${businessId}/catalog/location/${locationId}/items`,
    MERCHANT_OVERVIEW: (businessId: string) => `business/${businessId}/catalog/overview`,
    INTEGRATIONS: `integrations/`,
    PUBLISH_INTEGRATIONS: (businessId: string, locationId: string, integrationId: string, menuId: string) =>
      `business/${businessId}/menu/location/${locationId}/integration/${integrationId}/publish/${menuId}`,
    EDIT_MENU: (businessId: string, menuId) => `business/${businessId}/menu/${menuId}`,
    ORDERS: "orders/",
    ORDER: (orderId: string) => `orders/${orderId}`,
    RESEND_ORDER: (orderId: string) => `orders/${orderId}/resend`,
  },
  LOGIN: "auth/login",
  LOG_OUT: "auth/logout",
  RESET_PASSWORD: "auth/reset-password",
  CUSTOMERS: "business/directory/customers",
  CUSTOMER: (customer_id) => `business/directory/customers/${customer_id}`,

  CUSTOMER_INSIGHTS: (id: string, location_id: string = "") =>
    `business/reporting/customers/${id}/insights?mode=full&location_id=${location_id}`,

  CUSTOMERS_LIST: "business/directory/customers/reports",
  BUSINESS: "business",
  LOCATIONS: "business/locations",
  LOCATION_DETAILS: (locationId) => `business/locations/${locationId}`,

  ORDER_OPTIONS: "business/order-options",
  LOCATION_ORDER_OPTIONS: ({ locationId = "" }): string => `/locations/${locationId}/order-options`,
  PAYMENT_METHODS: "business/payment-methods",
  CREATE_CATEGORY: "/business/catalog/categories",
  GET_CATEGORY: (category_id: string): string => {
    return `/business/catalog/categories/${category_id}`;
  },

  TAXES: "/business/catalog/taxes",
  TAX: "/business/catalog/taxes",

  CATEGORIES: (mode: string = MODES.SUMMARY, page_size: number = 32, search: string): string => {
    return `business/catalog/categories?mode=${mode}&page_size=${page_size}&search=${search}`;
  },

  SPECIFIC_CATEGORIES: (mode: string = MODES.SUMMARY, page_size: number = 32, categories: string): string => {
    return `business/catalog/categories?mode=${mode}&page_size=${page_size}&categories=${categories}`;
  },

  ALL_ITEMS: (mode: string = MODES.SUMMARY, page_size: number = 32, search: string): string => {
    return `business/catalog/items?mode=${mode}&page_size=${page_size}&search=${search}`;
  },

  SPECIFIC_ITEMS: (mode: string = MODES.SUMMARY, page_size: number = 32, items: string): string => {
    return `business/catalog/items?mode=${mode}&page_size=${page_size}&items=${items}`;
  },

  ITEMS: (location: string, mode: string = MODES.SUMMARY, page_size: number = 32): string => {
    return `locations/${location}/items?mode=${mode}&page_size=${page_size}`;
  },

  ITEM: (location_id: string, item_id: string): string => {
    return `locations/${location_id}/items/${item_id}`;
  },

  EXTRA_CHARGES: (search: string, page: number, page_size: number = 32): string => {
    return `/business/extra-charges?search=${search}&page=${page}&page_size=${page_size}`;
  },
  EXTRA_CHARGE: "/business/extra-charges",
  DISCOUNTS: `business/discounts`,

  LOCATION_ITEM_DISCOUNTS: (location_id: string, category_id: string, item_id: string): string => {
    return `business/discounts/list?location_id=${location_id}&category_id=${category_id}&item_id=${item_id}`;
  },

  DELIVERY_FEES: (location_id: string, area_id: string): string => {
    return `locations/${location_id}/delivery/costs?area_id=${area_id}`;
  },

  ADDRESS: {
    CITIES: (country_code: string): string => `business/directory/countries/${country_code}/cities`,
    AREAS: (country_code: string, city_id: string,filter): string =>
      `/business/locations/delivery-areas/${country_code}/${city_id}?${filter}`,
    AVENUES: ({ countryCode = "", cityId = "", areaId = "" }): string =>
      `mc/countries/${countryCode}/cities/${cityId}/areas/${areaId}`,
  },

  EXCHANGES: "/business/exchanges",

  CURRENCIES: "/currencies",

  /**
   * @param location_id
   * @param mode
   * @param creator_id
   * @param page_size
   * @param page
   * @param search
   * @param status
   * @param location_list
   * @param creation_time_from
   * @param creation_time_to
   * @param count_status
   * @param count_payment_status
   * @param payment_status
   * @param customer_id
   * @param source
   */

  TABS: ({
    location_id,
    mode = MODES.FULL,
    creator_id = "",
    page_size = 1000,
    page = 1,
    search = "",
    status = "",
    location_list = "",
    creation_time_from = "",
    creation_time_to = "",
    count_status = false,
    count_payment_status = false,
    payment_status = "",
    customer_id = "",
    source = ORDER_SOURCE.CALLCENTER,
  }) =>
    `locations/${location_id}/tabs?page=${page}&page_size=${page_size}&creator=${creator_id}&mode=${mode}&search=${search}&status=${status}&location_list=${location_list}&creation_time_from=${creation_time_from}&creation_time_to=${creation_time_to}&count_status=${count_status}&count_payment_status=${count_payment_status}&
payment_status=${payment_status}&customer_id=${customer_id}&source=${source}`, //

  TAB: (location_id: string, tab_id: string) => {
    return `locations/${location_id}/tabs/${tab_id}`;
  },
  CALCULATOR_TAB: "/calculator/tabs/calculate",
  STORE_TAB: (location_id: string = "") => `/locations/${location_id}/tabs`,
  UNITS: "/business/inventory/units",
  TAGS: "business/directory/tags",
  DRIVERS: `business/delivery/drivers`,
  DRIVERS_BATCH: `/business/delivery/drivers/batch`,
  TEAMS: `business/delivery/categories`,
  TEAMS_BATCH: `business/delivery/categories/batch`,
  TEAM_DELETE: (teamId) => `business/delivery/categories/${teamId}`,
  SALE_AGGREGATES: (location_ids: string, begin: string, end: string, customer_id: string): string => {
    return `business/transactions/sales-aggregates?${location_ids}&begin_time=${begin}&end_time=${end}&customer=${customer_id}`;
  },

  SALE: (sale_id: string): string => {
    return `business/transactions/sales/${sale_id}`;
  },

  TRANSACTION_DETAILS: ({ location_id = "", tab_id = "", page_size = 1 }): string => {
    return `locations/${location_id}/transactions/sales?page_size=${page_size}&tab_id=${tab_id}`;
  },

  /**
   * @param location_id
   * @param offset
   * @param begin_time
   * @param end_time
   * @param carry
   */
  MOST_POPULAR: ({ location_id, offset = 0, begin_time = "", end_time = "", carry = "" }): string =>
    `locations/${location_id}/reporting/catalog/items/group-by-period?offset=${offset}&begin_time=${begin_time}&end_time=${end_time}&carry=${carry}`,

  AGENTS: (page_size: number = 270): string => `business/users?agent=true&page_size=${page_size}`,
  TAB_COUNTER: "business/tabs/tab_counter",
  AREAS: "/locations/areas",

  LOCATION_BY_AREA: `business/locations/delivery-areas/`, //areaIds.join(',')
  DEFAULT_LOCATION_BY_AREA: (location_id: string = "") =>
    `/business/locations/delivery-areas/${location_id}/default-areas/`,
  DEFAULT_LOCATION: (location_id: string = "") => `business/locations/${location_id}/set-default`,

  /**
   * @param location_list
   * @param creation_time_from
   * @param creation_time_to
   */
  TABS_BY_STATUS_TIME_COUNTER: ({ location_list, creation_time_from, creation_time_to, status, source }): string =>
    `business/tabs/by-status-time/counter?location_list=${location_list}&creation_time_to=${creation_time_to}&creation_time_from=${creation_time_from}&status=${status}&source=${source}`,

  LOCATION_ORDERS_NUMBER: ({ locationsIds, begin_time, end_time, status, source }): string =>
    `business/tabs/reporting/tabs/locations-orders?location_id=${locationsIds}&begin_time=${begin_time}&end_time=${end_time}&status=${status}&source=${source}`,

  TOP_SELLING_ITEMS: ({ locationsIds, begin_time, end_time, page_size, page, status, source }): string =>
    `business/tabs/reporting/tabs/items-top-selling?location_id=${locationsIds}&begin_time=${begin_time}&end_time=${end_time}&page_size=${page_size}&page=${page}&status=${status}&source=${source}`,

  TOP_SELLING_AREA: ({ locationsIds, begin_time, end_time, page_size, page, status, source }): string =>
    `business/tabs/reporting/tabs/top-selling-areas?location_id=${locationsIds}&begin_time=${begin_time}&end_time=${end_time}&page_size=${page_size}&page=${page}&status=${status}&source=${source}`,

  TOP_SELLING_AGENT: ({ location_id, begin_time, end_time, page_size, page, status, source }): string =>
    `business/tabs/reporting/tabs/top-selling-agents?location_id=${location_id}&begin_time=${begin_time}&end_time=${end_time}&page_size=${page_size}&page=${page}&status=${status}&source=${source}`,

  LOCATION_DELIVERY_TIME: ({ locationsIds, begin_time, end_time, page_size, page, status, source }): string =>
    `business/tabs/reporting/tabs/quickest-serving-locations?location_id=${locationsIds}&begin_time=${begin_time}&end_time=${end_time}&page_size=${page_size}&page=${page}&status=${status}&source=${source}`,

  SALES_INDICATORS: ({ locationsIds, begin_time, end_time, page_size, page, status, source }): string =>
    `business/tabs/reporting/tabs/dashboard-indecators?location_id=${locationsIds}&begin_time=${begin_time}&end_time=${end_time}&page_size=${page_size}&page=${page}&status=${status}&source=${source}`,

  /**
   * Digital menu
   */
  DIGITAL_MENU: (location_id: string = "") => `locations/${location_id}/menu`,

  PAYMENT_CATEGORIES: 'business/payment-categories',
};

export default ENDPOINTS;
